// extracted by mini-css-extract-plugin
module.exports = {"tab":"dashboard_tab__1nzBA","sup":"dashboard_sup__1mcHA","usedTitle":"dashboard_usedTitle__1p2RU"};